import { privateApi } from "../api/axios";

export const getBillingFrequencies = async () => {
    try {
        const response = await privateApi.get("api/billingfrequencies");
        return response;
    } catch (error) {
        throw error;
    }
}